"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scaleElement = scaleElement;
var _operations = require("./_operations");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*************************************************************
                      KONVA TRANSFORMS
**************************************************************/
function scaleElement(el, scaleFinal, origin) {
  var _origin;
  var boundingBox = el.getClientRect();
  var shape = {
    x: el.x(),
    y: el.y(),
    width: el.width() || boundingBox.width,
    height: el.height() || boundingBox.height,
    scale: el.scale()
  };

  // use shape center if origin not provided
  origin = (_origin = origin) !== null && _origin !== void 0 ? _origin : (0, _operations.getRelativeCenter)(shape);
  var scaleInitial = shape.scale;
  var scaleDelta = {
    x: scaleFinal.x / scaleInitial.x,
    y: scaleFinal.y / scaleInitial.y
  };
  var position = {
    x: shape.x - (origin.x - shape.x) * (scaleDelta.x - 1),
    y: shape.y - (origin.y - shape.y) * (scaleDelta.y - 1)
  };
  el.setAttrs(_objectSpread(_objectSpread({}, shape), {}, {
    position: position,
    scale: scaleFinal
  }));
}